import React from "react";
// import "../../TermsAndConditions.css";

const WarrantyPolicies = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Warranty Policy</h1>

            <section className="tc-section">
                <h2>1. Warranty Coverage</h2>
                <p>
                    All products sold by Way4Track (Sharon Telematics Private Limited)
                    are covered under a limited warranty of 1 (one) year from the date of delivery.
                </p>
                <p>This warranty applies only to:</p>
                <ul>
                    <li>Manufacturing defects</li>
                    <li>Functional issues under normal usage</li>
                </ul>
                <p>
                    This warranty ensures products perform under standard conditions.
                    It does not guarantee full replacement in all cases.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Scope of Warranty</h2>
                <ul>
                    <li>Repair of defective components</li>
                    <li>Replacement of specific faulty parts</li>
                </ul>
                <p>
                    For multi-component products, only the affected part will be repaired
                    or replaced, not the entire unit.
                </p>
            </section>

            <section className="tc-section">
                <h2>3. Service Process</h2>
                <ul>
                    <li>Customer must contact support</li>
                    <li>Initial troubleshooting may be remote</li>
                    <li>Inspection arranged if required</li>
                </ul>
                <p>
                    Service may be on-site or at a service center depending on the issue.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Conditions for Warranty Validity</h2>
                <ul>
                    <li>Used under normal conditions</li>
                    <li>No misuse or physical damage</li>
                    <li>Installed as per company guidelines</li>
                </ul>
                <p>
                    Failure to meet these conditions may result in rejection of the claim.
                </p>
            </section>

            <section className="tc-section">
                <h2>5. Installation Requirement</h2>
                <p>
                    Warranty is valid only when installation is done properly.
                    Unauthorized installation may void warranty.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. Warranty Exclusions</h2>
                <ul>
                    <li>Physical damage or mishandling</li>
                    <li>Improper usage</li>
                    <li>Unauthorized repairs or modifications</li>
                    <li>Damage from water, fire, or electrical issues</li>
                    <li>Normal wear and tear</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>7. Technician Visit & Charges</h2>
                <p>
                    Technician visits may be chargeable depending on location,
                    issue type, and service requirements.
                </p>
            </section>

            <section className="tc-section">
                <h2>8. Service Timeline</h2>
                <p>
                    Timelines vary based on issue complexity, spare availability,
                    and location. Exact timelines are not guaranteed.
                </p>
            </section>

            <section className="tc-section">
                <h2>9. Limitation of Warranty</h2>
                <p>
                    Warranty is limited to repair or replacement only.
                </p>
                <ul>
                    <li>No refunds</li>
                    <li>No compensation for downtime</li>
                    <li>No indirect damages covered</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>10. Final Decision</h2>
                <p>
                    All claims are subject to technical evaluation and approval by Way4Track.
                    The Company’s decision will be final.
                </p>
            </section>

        </div>
    );
};

export default WarrantyPolicies;